import { jsPDF } from "jspdf";

export const generateOthePDF_CCK = (practice_id, practice, pdfSend) => {
  const doc = new jsPDF();
  const pageHeight = doc.internal.pageSize.height; // Usa l'altezza effettiva della pagina

  doc.setFontSize(16); // Font per il titolo
  doc.text(`Riepilogo pratica #${practice_id}`, 10, 10);

  let y = 20;
  const lineHeight = 8;
  // const pageHeight = 380;
  const bottomMargin = 40;

  /**
   * Aggiunge una riga al PDF con font fisso di 14px.
   * @param {string} label - Testo della chiave (label).
   * @param {string} value - Valore associato alla chiave.
   */
  const addLine = (label, value) => {
    // Controlla se il testo va oltre il margine inferiore
    if (y + lineHeight + bottomMargin > pageHeight) {
      doc.addPage();
      y = 10;
    }

    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`${label}:`, 10, y);

    doc.setFont("helvetica", "normal");

    const maxWidth = 80;
    const splitValue = doc.splitTextToSize(value, maxWidth);

    doc.text(splitValue, 120, y);

    y += lineHeight * splitValue.length;
  };

  // step 1
  doc.setTextColor(188, 41, 87);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("Step 1 - Incarico", 10, y);

  y += lineHeight * 0.5;

  doc.setTextColor(0, 0, 0);
  doc.setDrawColor(169, 169, 169);
  doc.setLineWidth(0.5);
  doc.line(10, y, 200, y);

  y += lineHeight;

  // step 1

  addLine("Nome della pratica", practice?.Incarico?.Nome_pratica || "");

  addLine(
    "Dipartimento Elibra",
    practice?.Incarico?.Team_riferimento?.name || ""
  );
  addLine(
    "Prodotto richiesto",
    practice?.Incarico?.Prodotto_richiesto?.name || ""
  );
  addLine(
    "Valore associato alla pratica",
    practice?.Incarico?.valore_associato_pratica || ""
  );
  addLine(
    "Responsabile della pratica",
    practice?.Incarico?.responsabile_pratica || ""
  );

  // step 2
  y += lineHeight * 1;

  doc.setTextColor(188, 41, 87);
  doc.setFontSize(14);
  doc.setFont("helvetica", "bold");
  doc.text("Step 2 - Cliente", 10, y);

  y += lineHeight * 0.5;

  doc.setTextColor(0, 0, 0);
  doc.setDrawColor(169, 169, 169);
  doc.setLineWidth(0.5);
  doc.line(10, y, 200, y);

  y += lineHeight;

  // step 2

  addLine("Status", practice?.cliente?.status || "");
  addLine("Tipologia", practice?.cliente?.tipologia || "");

  if (practice?.cliente?.segmento_operatività) {
    addLine(
      "Segmento di operatività",
      practice?.cliente?.segmento_operatività || ""
    );
  }

  if (practice?.cliente.lingua_corrispondenza) {
    addLine(
      "Lingua di corrispondenza",
      practice?.cliente?.lingua_corrispondenza || ""
    );
  }

  if (practice?.cliente?.tipologia === "Persona fisica italiana") {
    addLine("Nome", practice?.cliente?.nome || "");
    addLine("Cognome", practice?.cliente?.cognome || "");

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.codice_fiscale) {
        addLine(
          "Partita IVA o Codice fiscale",
          practice.cliente.codice_fiscale
        );
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }

      if (
        practice?.cliente?.cliente_affiliato_gruppo_societari &&
        practice?.cliente?.cliente_affiliato_gruppo_societari === "Sì"
      ) {
        addLine(
          "Il Cliente è affiliato a gruppi societari",
          practice?.cliente?.cliente_affiliato_gruppo_societari
        );
      }

      if (practice?.cliente?.cliente_collegamento_societa) {
        addLine(
          "Società/gruppo con cui il cliente è collegato",
          practice?.cliente?.cliente_collegamento_societa
        );
      }

      if (practice?.cliente?.cliente_ruolo) {
        addLine("Ruolo", practice?.cliente?.cliente_ruolo);
      }

      if (practice?.cliente?.cliente_altro) {
        addLine("Altro", practice?.cliente?.cliente_altro);
      }
    }
  }

  if (practice?.cliente?.tipologia === "Persona fisica altro paese UE") {
    if (practice?.cliente?.nome) {
      addLine("Nome", practice.cliente.nome);
    }
    if (practice?.cliente?.cognome) {
      addLine("Cognome", practice.cliente.cognome);
    }

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.codice_fiscale) {
        addLine("VAT number o Fiscal code", practice.cliente.codice_fiscale);
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }
      if (
        practice?.cliente?.cliente_affiliato_gruppo_societari &&
        practice?.cliente?.cliente_affiliato_gruppo_societari === "Sì"
      ) {
        addLine(
          "Il Cliente è affiliato a gruppi societari",
          practice?.cliente?.cliente_affiliato_gruppo_societari
        );
      }

      if (practice?.cliente?.cliente_collegamento_societa) {
        addLine(
          "Società/gruppo con cui il cliente è collegato",
          practice?.cliente?.cliente_collegamento_societa
        );
      }

      if (practice?.cliente?.cliente_ruolo) {
        addLine("Ruolo", practice?.cliente?.cliente_ruolo);
      }

      if (practice?.cliente?.cliente_altro) {
        addLine("Altro", practice?.cliente?.cliente_altro);
      }
    }
  }

  if (practice?.cliente?.tipologia === "Persona fisica extra UE") {
    if (practice?.cliente?.nome) {
      addLine("Nome", practice.cliente.nome);
    }
    if (practice?.cliente?.cognome) {
      addLine("Cognome", practice.cliente.cognome);
    }

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.codice_fiscale) {
        addLine("VAT number o Fiscal code", practice.cliente.codice_fiscale);
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }

      if (
        practice?.cliente?.cliente_affiliato_gruppo_societari &&
        practice?.cliente?.cliente_affiliato_gruppo_societari === "Sì"
      ) {
        addLine(
          "Il Cliente è affiliato a gruppi societari",
          practice?.cliente?.cliente_affiliato_gruppo_societari
        );
      }

      if (practice?.cliente?.cliente_collegamento_societa) {
        addLine(
          "Società/gruppo con cui il cliente è collegato",
          practice?.cliente?.cliente_collegamento_societa
        );
      }

      if (practice?.cliente?.cliente_ruolo) {
        addLine("Ruolo", practice?.cliente?.cliente_ruolo);
      }

      if (practice?.cliente?.cliente_altro) {
        addLine("Altro", practice?.cliente?.cliente_altro);
      }
    }
  }

  if (practice?.cliente?.tipologia === "Persona giuridica italiana") {
    if (practice?.cliente?.denominazione_sociale) {
      addLine("Denominazione sociale", practice.cliente.denominazione_sociale);
    }

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.partita_iva) {
        addLine("Partita IVA o Codice fiscale", practice.cliente.partita_iva);
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }

      if (
        practice?.cliente?.appartiene_gruppo_societario &&
        practice?.cliente?.appartiene_gruppo_societario === "Sì"
      ) {
        addLine(
          "Il cliente appartiene a un gruppo societario",
          practice?.cliente?.appartiene_gruppo_societario
        );
      }

      if (practice?.cliente?.denominazione_gruppo_holding) {
        addLine(
          "Denominazione del gruppo/holding",
          practice?.cliente?.denominazione_gruppo_holding
        );
      }

      if (practice?.cliente?.capogruppo) {
        addLine(
          "Capogruppo (società controllante)",
          practice?.cliente?.capogruppo
        );
      }

      if (practice?.cliente?.relazione_cliente_gruppo) {
        addLine(
          "Ruolo/relazione del cliente nel gruppo",
          practice?.cliente?.relazione_cliente_gruppo
        );
      }

      if (practice?.cliente?.gruppo_societa_rilevante) {
        addLine(
          "Società del gruppo rilevanti ai fini del mandato",
          practice?.cliente?.gruppo_societa_rilevante
        );
      }

      if (practice?.cliente?.altre_controparti) {
        addLine("Altro", practice?.cliente?.gruppo_societa_rilevante);
      }
    }
  }

  if (practice?.cliente?.tipologia === "Persona giuridica altro paese UE") {
    if (practice?.cliente?.denominazione_sociale) {
      addLine("Denominazione sociale", practice.cliente.denominazione_sociale);
    }

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.partita_iva) {
        addLine("VAT number", practice.cliente.partita_iva);
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }

      if (
        practice?.cliente?.appartiene_gruppo_societario &&
        practice?.cliente?.appartiene_gruppo_societario === "Sì"
      ) {
        addLine(
          "Il cliente appartiene a un gruppo societario",
          practice?.cliente?.appartiene_gruppo_societario
        );
      }

      if (practice?.cliente?.denominazione_gruppo_holding) {
        addLine(
          "Denominazione del gruppo/holding",
          practice?.cliente?.denominazione_gruppo_holding
        );
      }

      if (practice?.cliente?.capogruppo) {
        addLine(
          "Capogruppo (società controllante)",
          practice?.cliente?.capogruppo
        );
      }

      if (practice?.cliente?.relazione_cliente_gruppo) {
        addLine(
          "Ruolo/relazione del cliente nel gruppo",
          practice?.cliente?.relazione_cliente_gruppo
        );
      }

      if (practice?.cliente?.gruppo_societa_rilevante) {
        addLine(
          "Società del gruppo rilevanti ai fini del mandato",
          practice?.cliente?.gruppo_societa_rilevante
        );
      }

      if (practice?.cliente?.altre_controparti) {
        addLine("Altro", practice?.cliente?.gruppo_societa_rilevante);
      }
    }
  }

  if (practice?.cliente?.tipologia === "Persona giuridica extra UE") {
    if (practice?.cliente?.denominazione_sociale) {
      addLine("Denominazione sociale", practice.cliente.denominazione_sociale);
    }

    if (practice?.cliente?.status === "Nuovo cliente") {
      if (practice?.cliente?.partita_iva) {
        addLine("VAT number", practice.cliente.partita_iva);
      }
      if (practice?.cliente?.comune) {
        addLine("Comune", practice.cliente.comune);
      }
      if (practice?.cliente?.indirizzo) {
        addLine("Indirizzo e Civico", practice.cliente.indirizzo);
      }
      if (practice?.cliente?.CAP) {
        addLine("CAP", practice.cliente.CAP);
      }

      if (
        practice?.cliente?.appartiene_gruppo_societario &&
        practice?.cliente?.appartiene_gruppo_societario === "Sì"
      ) {
        addLine(
          "Il cliente appartiene a un gruppo societario",
          practice?.cliente?.appartiene_gruppo_societario
        );
      }

      if (practice?.cliente?.denominazione_gruppo_holding) {
        addLine(
          "Denominazione del gruppo/holding",
          practice?.cliente?.denominazione_gruppo_holding
        );
      }

      if (practice?.cliente?.capogruppo) {
        addLine(
          "Capogruppo (società controllante)",
          practice?.cliente?.capogruppo
        );
      }

      if (practice?.cliente?.relazione_cliente_gruppo) {
        addLine(
          "Ruolo/relazione del cliente nel gruppo",
          practice?.cliente?.relazione_cliente_gruppo
        );
      }

      if (practice?.cliente?.gruppo_societa_rilevante) {
        addLine(
          "Società del gruppo rilevanti ai fini del mandato",
          practice?.cliente?.gruppo_societa_rilevante
        );
      }

      if (practice?.cliente?.altre_controparti) {
        addLine("Altro", practice?.cliente?.gruppo_societa_rilevante);
      }
    }
  }

  if (pdfSend) {
    const pdfBlob = doc.output("blob");
    return pdfBlob;
  } else {
    doc.save(`Riepilogo_pratica_${practice_id}.pdf`);
  }
};
